import { RouteObject } from 'react-router-dom';
import { RouteMeta } from '@/pages/routes';

const route: RouteObject = {
	path: 'bank',
	lazy: async () => ({ Component: (await import('@/modules/bank/Layout')).default }),
	children: [
		{
			path: 'accounts',
			index: true,
			id: 'bankAccounts',
			loader: () => ({
				meta: {
					title: 'Bank Accounts',
					disabled: true,
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/bank/pages/BankAccounts')).default }),
		},
		{
			path: 'withdrawals',
			index: true,
			id: 'withdrawals',
			loader: () => ({
				meta: {
					title: 'Bank Withdrawals',
					disabled: true,
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/bank/pages/Withdrawals')).default }),
		},
		{
			path: 'deposits',
			index: true,
			id: 'deposits',
			loader: () => ({
				meta: {
					title: 'Bank Deposits',
					disabled: true,
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/bank/pages/Deposits')).default }),
		},
	],
};
export default route;
